import { render, staticRenderFns } from "./HighlightNumber.vue?vue&type=template&id=6c09ae93&"
import script from "./HighlightNumber.vue?vue&type=script&lang=js&"
export * from "./HighlightNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports